<div class="activityAdvancedPaymentDialog">

    <div kalDialogContent>
        <div class="advanced-payment-container">
            <app-shared-advanced-settlement
                *ngIf="isAdvancedSettlementDisplayed"
                (invoicePaidByCreditDeposit)="invoicePaidByCreditDeposit()">
            </app-shared-advanced-settlement>
        </div>
    </div>

    <div kalDialogFooter>

        <div class="gup-C-validationArea gup-O-list">

            <div class="gup-O-list__item">
                <kal-button kalTheme="primary"
                            id="activity_advanced_payment_dialog_save"
                            [disabled]="!canPay || loading"
                            (click)="save()">
                    Valider
                </kal-button>
            </div>
            <div class="gup-O-list__item">
                <kal-button kalTheme="secondary"
                            id="activity_advanced_payment_dialog_cancel"
                            [disabled]="loading"
                            (click)="cancel()">
                    Annuler
                </kal-button>
            </div>
        </div>

    </div>

</div>
